import AssetUploadJob from '@aytm/app/stats/page/assets/jobs/AssetUploadJob'

export default function upload(file, uploadUrl, statusUrl, contentType, accessKey, onProgress) {
  return new Promise((resolve, reject) => {
    AssetUploadJob({
      file,
      uploadUrl,
      statusUrl,
      contentType,
      params: { key: accessKey }
    })
      .then(
        data => {
          resolve(data)
        },
        null,
        (progress, totalProgress) => {
          onProgress(progress, totalProgress)
        }
      )
      .catch(error => {
        reject(error)
      })
  })
}
